import styled from "styled-components";
import {BasicModalTitle, BasicModalWrapper} from "../../../../../../../Theme/modalsElements";
import {BasicContentParagraph} from "../../../../../../../Theme/basicElements";

export const CancelModal = styled(BasicModalWrapper)`
  width: 512px;
`;

export const CancelModalTitle = styled(BasicModalTitle)`
  text-align: center;
`;

export const CancelModalText = styled(BasicContentParagraph)`
  text-align: center;
  margin-bottom: 48px;
`;

export const CancelModalButtonsBlock = styled.div`
  display: flex;
  gap: ${props => props.theme.format.main_lg_gap};
  width: 100%;
  justify-content: center;
`;